import { render, staticRenderFns } from "./HcButton.vue?vue&type=template&id=3f875bd6"
import script from "./HcButton.vue?vue&type=script&lang=js"
export * from "./HcButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports